import * as React from 'react'
import {BUTTON_SHOW_ORDERS} from '../../../config/data-hooks'
import {Routes} from '../../../types/state'
import {EventLink} from '../../styled-components/event-link'
import {GoToOrderButtonProps} from './index'

export const GoToOrderButton = ({event, internalNavigate, t}: GoToOrderButtonProps) => (
  <EventLink
    secondary={true}
    mobile={true}
    as="a"
    onClick={() => internalNavigate(Routes.ORDER_LIST, {event})}
    data-hook={BUTTON_SHOW_ORDERS}
  >
    {t('events.buttons.order-details')}
  </EventLink>
)
